import PropTypes from 'prop-types';
import React from 'react';

const PageHeader = ({ title, subtitle, imageUrl, imageAlt }) => {
  return (
    <div className="relative mb-10">
      {/* Background Image */}
      <div className="relative h-80 md:h-[50vh] w-full overflow-hidden rounded-lg">
        <img 
          src={imageUrl} 
          alt={imageAlt || title} 
          className="w-full h-full object-cover"
        />
        <div className="absolute inset-0 h-full w-full bg-black rounded-md bg-clip-padding backdrop-filter backdrop-blur-sm bg-opacity-50 border  flex items-center justify-center">
          <div className="text-center w-full h-full flex flex-col justify-end  text-white px-4">
            <h1 className="text-2xl md:text-3xl">{title}</h1>
            {subtitle && <p className="text-sm md:text-l font-schoolbook font-light mb-2">{subtitle}</p>}
          </div>
        </div>
      </div>
    </div>
  );
};

PageHeader.propTypes = {
  title: PropTypes.string.isRequired,
  subtitle: PropTypes.string.isRequired,
  imageUrl: PropTypes.string.isRequired,
  imageAlt: PropTypes.string
};

export default PageHeader; 